module.exports = __webpack_public_path__ + "img/verification-bg.ca9b19fc.jpg";